module.exports = "/_next/static/images/CustomSources@3x-5311816529dd0d8d32e90d8247c0f8cb.webp";